import PropTypes from "prop-types";

/**
 * Reusable Badge component for tables with 4 color modes
 * Uses light backgrounds with colored text and borders for better UX
 */
const TableBadge = ({ children, variant = "info", size = "sm", className = "", ...props }) => {
    // Define variant styles with light backgrounds and colored text/borders
    const variantStyles = {
        info: "bg-info/20 border-info/30",
        warning: "bg-warning/20 border-warning/30",
        error: "bg-error/20 border-error/30",
        success: "bg-success/20 border-success/30",
    };

    // Size variants
    const sizeStyles = {
        xs: "badge-xs",
        sm: "badge-sm",
        md: "badge-md",
        lg: "badge-lg",
    };

    const baseClasses = "badge border text-base-content";
    const variantClass = variantStyles[variant] || variantStyles.info;
    const sizeClass = sizeStyles[size] || sizeStyles.sm;

    return (
        <span className={`${baseClasses} ${variantClass} ${sizeClass} ${className}`} {...props}>
            {children}
        </span>
    );
};

TableBadge.propTypes = {
    children: PropTypes.node.isRequired,
    variant: PropTypes.oneOf(["info", "warning", "error", "success"]),
    size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
    className: PropTypes.string,
};

export default TableBadge;
